import { render, staticRenderFns } from "./IconPassengerBus.vue?vue&type=template&id=27d1ac72"
import script from "./IconPassengerBus.vue?vue&type=script&lang=js"
export * from "./IconPassengerBus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports